import React from 'react';
import { useInfoCard } from '../hooks/useInfoCard';
import { textPositionTokens } from '../tokens';

export function InfoCardContainer({ children }) {
	const { isFullModeStyle, imageUrl, textPosition, blockClass, componentId, handles } = useInfoCard();

	function renderTokens() {
		const justifyToken = textPositionTokens[textPosition || 'left'];
		const flexDirectionToken = textPosition === 'right' ? 'flex-row-reverse' : 'flex-row';

		if (isFullModeStyle) {
			return `bg-center bb b--muted-4 flex justify-${justifyToken}`;
		}

		return `flex-ns ${flexDirectionToken} bg-base ph2-ns pb2 justify-between`;
	}

	function renderStyles() {
		if (isFullModeStyle) {
			return {
				backgroundImage: `url('${imageUrl}')`,
				backgroundSize: 'cover',
			};
		}

		return {};
	}

	return (
		<div
			data-selection={componentId}
			className={`${handles.infoCardContainer} items-center ${renderTokens()}`}
			style={renderStyles()}
		>
			{children}
		</div>
	);
}
